import { THEME_STORAGE_KEY } from "../theme";

/**
 * Signing in or out wipes the browser's saved state, but the theme is a device preference,
 * not account data, so it is kept.
 */
export function clearAppStorage() {
    let theme = null;
    try {
        theme = localStorage.getItem(THEME_STORAGE_KEY);
    } catch {
        // Storage may be unavailable; nothing to keep.
    }
    localStorage.clear();
    sessionStorage.clear();
    if (theme) localStorage.setItem(THEME_STORAGE_KEY, theme);
}
